import { useEffect, useState } from "react";
import { AnimatePresence } from "framer-motion";
import Lenis from "lenis";
import "@/App.css";
import { useDeviceTier } from "@/lib/useDeviceTier";
import Environment3D from "@/components/three/Environment3D";
import Loader from "@/components/Loader";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Packages from "@/components/Packages";
import Work from "@/components/Work";
import Testimonials from "@/components/Testimonials";
import WhyUs from "@/components/WhyUs";
import Process from "@/components/Process";
import About from "@/components/About";
import Faq from "@/components/Faq";
import FinalCTA from "@/components/FinalCTA";
import Contact from "@/components/Contact";
import Congratulations from "@/components/Congratulations";
import TransitionWipe from "@/components/TransitionWipe";
import Footer from "@/components/Footer";

function App() {
  const [loading, setLoading] = useState(true);
  const [selectedPackage, setSelectedPackage] = useState("");
  const [launched, setLaunched] = useState(false);
  const [transitioning, setTransitioning] = useState(false);
  const [envReady, setEnvReady] = useState(false);
  const { tier, reducedMotion } = useDeviceTier();

  const goHomeCinematic = () => {
    setTransitioning(true);
    setTimeout(() => {
      setLaunched(false);
      if (window.__lenis) {
        window.__lenis.scrollTo(0, { immediate: true });
      } else {
        window.scrollTo(0, 0);
      }
    }, 550);
    setTimeout(() => setTransitioning(false), 1150);
  };

  useEffect(() => {
    const warm = setTimeout(() => setEnvReady(true), 1300);
    const t = setTimeout(() => setLoading(false), 2100);
    return () => {
      clearTimeout(warm);
      clearTimeout(t);
    };
  }, []);

  useEffect(() => {
    if (reducedMotion) return;
    const lenis = new Lenis({ duration: 1.0, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, [reducedMotion]);

  return (
    <div className="min-h-screen bg-[#050505] text-white antialiased">
      <AnimatePresence>{loading && <Loader key="loader" />}</AnimatePresence>
      {envReady && <Environment3D tier={tier} reducedMotion={reducedMotion} />}
      <div className="noise-overlay" />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Packages onChoose={setSelectedPackage} />
        <Work />
        <Testimonials />
        <WhyUs />
        <Process />
        <About />
        <Faq />
        <FinalCTA />
        <Contact selectedPackage={selectedPackage} onLaunched={() => setLaunched(true)} />
      </main>
      <Footer />
      <AnimatePresence>
        {launched && (
          <Congratulations key="congratulations" onHome={goHomeCinematic} />
        )}
      </AnimatePresence>
      <TransitionWipe active={transitioning} />
    </div>
  );
}

export default App;
